import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup, ControlLabel } from "react-bootstrap";
import Select from "react-select";
import "react-select/dist/react-select.css";
import "./index.css";

class NoteOriginDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedNoteOrigin: this.props.defaultValue ? this.props.defaultValue : undefined,
      noteOriginList: [
        {
          id: "alert",
          display_name: "Alert"
        },
        {
          id: "observation",
          display_name: "Observation"
        }
      ]
    };
  }

  handleChange = selectedOption => {
    this.setState({ selectedNoteOrigin: selectedOption });
    if (selectedOption) {
      this.props.change(selectedOption.id);
    } else {
      this.props.change(null);
    }
  };

  render = () => {
    const { selectedNoteOrigin, noteOriginList } = this.state;

    return (
      <div className="note-origin-dropdown">
        <FormGroup controlId="formNoteOriginSelect">
          <ControlLabel>Origin</ControlLabel>
          <Select
            name="note-origin-name"
            value={selectedNoteOrigin}
            onChange={this.handleChange}
            valueKey="id"
            labelKey="display_name"
            multi={false}
            options={noteOriginList}
          />
        </FormGroup>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(mapStateToProps)(NoteOriginDropdown);



// WEBPACK FOOTER //
// ./src/_components/NoteOriginDropdown/index.js